function countdownTimer(startTime,endTime,activityElement,countdownElement) {
    function updateTimer() {
        const now = new Date().getTime();
        const distance = endTime - now;
        if (distance < 0) {
            clearInterval(interval);
            hideActivity(activityElement,countdownElement);
            return;
        }
        else if(now < startTime){
            if(countdownElement){
                const days = Math.floor((startTime-now) / (1000 * 60 * 60 * 24));
                const hours = Math.floor(((startTime-now) % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor(((startTime-now) % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor(((startTime-now) % (1000 * 60)) / 1000);
                countdownElement.innerHTML = `${days}days ${hours}hours ${minutes}min ${seconds}s`;
            }
        }
        else if(startTime < now < endTime){
            showActivity(activityElement,countdownElement)
            if(countdownElement){
                const days = Math.floor(distance / (1000 * 60 * 60 * 24));
                const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((distance % (1000 * 60)) / 1000);
                countdownElement.innerHTML = `${days}days ${hours}hours ${minutes}min ${seconds}s`;
            }
        }
    }
    const interval = setInterval(updateTimer, 1000);
    updateTimer();
}
function showActivity(activityElement,countdownElement) {
    if(activityElement){
        activityElement.style.display = "block";
    }
    if(countdownElement){
        countdownElement.style.display = "block";
    }
}
function hideActivity(activityElement,countdownElement) {
    if(activityElement){
        activityElement.style.display = "none";
    }
    if(countdownElement){
        countdownElement.style.display = "none";
    }
}